import { Button, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { useNavigator, Route } from "../../routers/navigator";
import { useCurrentAccountStore } from "../../store/currentAccountStore";

export function EmptyDataMessage({ content }: { content: string }) {
  const navigate = useNavigator();

  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  return (
    <VStack justifyContent="center" alignItems="center" py={8} spacing={6}>
      <VStack alignItems="center" spacing={2}>
        <Text textAlign="center">{"This looks quite empty, doesn't it?"}</Text>
        <Text textAlign="center" textColor="gray.700">
          {content}
        </Text>
      </VStack>
      <Button
        variant="solid"
        colorScheme="primary"
        onClick={() => {
          navigate({
            route: Route.DataSources,
            accountId,
            state: { openSidebar: true },
          });
        }}
      >
        Add data source
      </Button>
    </VStack>
  );
}
